import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { linkedinIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { useShareContext } from '../../context/ShareContext';

interface LinkedInShareRoundProps {
  className?: string;
  onClick?: () => void;
}

export const LinkedInShareRound: React.FunctionComponent<LinkedInShareRoundProps> = ({
  className,
  onClick = () => {},
}) => {
  const { shareItems } = useShareContext();

  const linkItemClick = () => {
    onClick();
  };

  return (
    <IconButton className={`${styles.roundButton} ${className}`}>
      <a
        href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
          shareItems.linkedin,
        )}`}
        data-qa="linkedin-btn"
        onClick={linkItemClick}
        target="_blank"
        rel="noreferrer"
      >
        <div className={classNames(styles.iconWrapper, styles.linkedin)}>
          <Svg markup={linkedinIcon} className={styles.icon} />
        </div>
        LinkedIn
      </a>
    </IconButton>
  );
};
